import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  selector: '[sukaText]'
})
export class TextInput {
  @HostBinding('class.text-input') inputClass = true;
  /**
   * Set to `true` to display the invalid state.
   */
  @HostBinding('class.text-input--invalid') @Input() invalid = false;
  /**
   * Set to `true` to display the valid state.
   */
  @HostBinding('class.text-input--valid') @Input() valid = false;
  /**
   * Set to `true` to display a loading text input.
   */
  @HostBinding('class.skeleton') @Input() skeleton = false;
}
